export default {
  methods: {
    toastSuccess: function(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 3000,
        noCloseButton: true,
        toaster: 'b-toaster-top-center',
        variant: 'success',
        solid: true
      })
    },
    toastError: function(message) {
      this.$bvToast.toast(message || 'Something went wrong, please try again.', {
        autoHideDelay: 3000,
        noCloseButton: true,
        toaster: 'b-toaster-top-center',
        variant: 'danger',
        solid: true
      })
    },
  },
  created: function(){
    const vm = this;
    const flash = JSON.parse(localStorage.getItem('vue-flash'));

    if(flash){
      localStorage.removeItem('vue-flash');
      vm.$bvToast.toast(flash.message, {
        autoHideDelay: 3000,
        noCloseButton: true,
        toaster: 'b-toaster-top-center',
        variant: flash.type,
        solid: true
      });
    }
  }
}